var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.formatted))])
}
var staticRenderFns = []

export { render, staticRenderFns }